import sortedIndexBy from 'lodash/sortedIndexBy';

import { TtsPosition, WordBoundary } from '../../types';

export const findWordBoundaryForTrackPosition = (
  position: number,
  wordBoundariesForVoiceAndChunk: WordBoundary[],
): TtsPosition | undefined => {
  // this is going to be a very ... specific binary search because I'm too lazy to figure out the ideal solution
  // Basically, take the position, floor it. Binary search until we find the same integer.
  // Once we find that, iteratively search until we find the exact word that fits
  const intPos = Math.floor(position);
  let index = sortedIndexBy(
    wordBoundariesForVoiceAndChunk,
    [intPos, 0, '', 0, 0, 0, 0],
    (wordBoundary) => wordBoundary[0],
  );
  if (index >= wordBoundariesForVoiceAndChunk.length) {
    index = wordBoundariesForVoiceAndChunk.length - 1;
  }
  let closestWord = wordBoundariesForVoiceAndChunk[index];
  if (!closestWord) {
    return;
  }
  if (closestWord[0] > position && index > 0) {
    // Honestly no clue why this if statement fires but it safeguards for the case that lodash returns
    // an index further ahead of the position
    index -= 1;
    closestWord = wordBoundariesForVoiceAndChunk[index];
  }
  if (closestWord[2] === 'e') {
    return;
  }
  // Take this value and binary search until we find the right index
  // wordLength is at index 7 for DRM protected documents (when word is empty)
  let prevPos: TtsPosition = {
    trackPos: closestWord[0],
    textPos: closestWord[1],
    word: closestWord[2],
    paraTextPos: closestWord[3],
    paraIndex: closestWord[4],
    wordLength: closestWord[7],
  };
  for (const wordBoundary of wordBoundariesForVoiceAndChunk.slice(index) as WordBoundary[]) {
    const [trackPos, textPos, word, paraTextPos, paraIndex, , , wordLength] = wordBoundary;
    if (word === 'e') {
      // This is most likely the special character we add to end of the chunk. Skip setting its word boundary
      continue;
    }
    if (position < trackPos) {
      // If the distance between two words is over 10 seconds, word boundaries are probably out-of-sync.
      // This should be resolved pretty quickly, so clear the inaccurate tts position until then.
      return Math.abs(trackPos - prevPos.trackPos) > 10 ? undefined : prevPos;
    }
    prevPos = { trackPos, textPos, word, paraTextPos, paraIndex, wordLength };
  }
  return prevPos;
};
